import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';

import { onClickWhatsNewDateCta } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const IncognitoModeBlockOneContainer: FunctionComponent = () => {
  const props = {
    imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/incognito-mode/feature-incognito.svg`,
    imageAlt: '',
    imageObjectPosition: '50% 10%',
    title: features.incognitoMode.lxIncognitoModeOneBlockTitle,
    text: features.incognitoMode.lxIncognitoModeOneBlockBodyText,
    actionText: features.incognitoMode.lxFeaturesDownloadBumbleCta,
    actionUrl: TrackingLink.APPSFLYER_LINK,
  };

  return (
    <PageSectionCta
      title={props.title}
      text={props.text}
      action={{
        text: props.actionText,
        href: props.actionUrl,
        onClick: onClickWhatsNewDateCta,
      }}
      image={{
        src: props.imageSrc,
        objectPosition: props.imageObjectPosition,
      }}
      color="orange"
    />
  );
};
